module.exports = __webpack_public_path__ + "img/bgd7.97acd184.png";